export const initiativeColors = [
  'bg-pink-600',
  'bg-purple-600',
  'bg-green-600',
  'bg-red-600',
  'bg-black',
  'bg-indigo-600',
  'bg-orange-600',
  'bg-slate-600',
  'bg-gray-600',
  'bg-zinc-600',
  'bg-neutral-600',
  'bg-stone-600',
  'bg-amber-600',
  'bg-amber-600',
  'bg-lime-600',
  'bg-emerald-600',
  'bg-teal-600',
  'bg-cyan-600',
  'bg-sky-600',
  'bg-blue-600',
  'bg-violet-600',
  'bg-fuchsia-600',
  'bg-rose-600',
];

export const statusBgColors = {
  DRAFT: 'bg-indigo-100',
  ACTIVE: 'bg-green-100',
  READY: 'bg-blue-100',
  COMPLETED: 'bg-amber-100',
  ARCHIVED: 'bg-gray-100',
  PARKED: 'bg-pink-100',
  'READY FOR PLANNING': 'bg-blue-100',
  NEW: 'bg-green-100',
};

export const statusTextColors = {
  DRAFT: 'text-indigo-700',
  ACTIVE: 'text-green-700',
  'READY FOR PLANNING': 'text-blue-700',
  READY: 'text-blue-700',
  COMPLETED: 'text-amber-700',
  ARCHIVED: 'text-gray-700',
  PARKED: 'text-pink-700',
  NEW: 'text-green-700',
};

export const ideaStatusBgColors = new Map([
  ['NEW', 'bg-green-100'],
  ['PARKED', 'bg-pink-100'],
  ['LONG_LIST', undefined],
  ['SHORT_LIST', undefined],
  ['INCOMPLETE', 'bg-amber-100'],
  ['IN_DEVELOPMENT', undefined],
  ['IN_REVIEW', 'bg-blue-100'],
  ['DONE', 'bg-indigo-100'],
]);

export const ideaStatusTextColors = new Map([
  ['NEW', 'text-green-700'],
  ['PARKED', 'text-pink-700'],
  ['LONG_LIST', undefined],
  ['SHORT_LIST', undefined],
  ['INCOMPLETE', 'text-amber-700'],
  ['IN_DEVELOPMENT', undefined],
  ['IN_REVIEW', 'text-blue-700'],
  ['DONE', 'text-indigo-700'],
]);

export const getColorFromInitiativeTitle = (string) => {
  const numHash = Array.from(string).reduce((acc, _, index) => {
    return (acc += string.charCodeAt(index));
  }, 0);
  const index = numHash % initiativeColors.length;
  return initiativeColors[index];
};
